import { useEffect, useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditorBuild from '@ckeditor/ckeditor5-build-classic';

type Props = {
  value: string;
  onChange: (val: string) => void;
};

const JobDescriptionEditor = ({ value, onChange }: Props) => {
  const editorRef = useRef<HTMLDivElement | null>(null);

  // Auto-resize logic
  const autoResize = () => {
    if (!editorRef.current) return;
    const editable = editorRef.current.querySelector('.ck-editor__editable');

    if (editable) {
      (editable as HTMLElement).style.height = 'auto';
      (editable as HTMLElement).style.height = editable.scrollHeight + 'px';
    }
  };

  useEffect(() => {
    autoResize();
  }, [value]);

  return (
    <div className="w-full">
      <label className="text-sm font-bold text-navy-700">Job Description</label>

      <div
        ref={editorRef}
        className="mt-1 border border-gray-300 rounded-md bg-white min-h-[140px]"
      >
        <CKEditor
          editor={ClassicEditorBuild as any}
          data={value}
          onChange={(_, editor) => {
            const data = editor.getData();
            onChange(data);
          }}
          onReady={() => autoResize()}
          config={{
            toolbar: ['bold', 'italic', 'link', 'undo', 'redo'],
          }}
        />
      </div>

      <style>
        {`
            .ck-editor__editable_inline {
            padding: 0.75rem !important; /* same as p-3 */
            border-radius: 0.75rem !important; /* same as rounded-xl */
            border: 1px solid #e5e7eb !important; /* same as border-gray-200 */
            }
            .ck-content ul,
            .ck-content ol {
            margin-left: 1rem !important; /* prevent bullets from touching the border */
            }
        `}
      </style>
    </div>
  );
};

export default JobDescriptionEditor;
